import { SessionList } from './SessionList';
import { SessionDetail } from './SessionDetail';

/**
 * 보스베이비 채팅 로그 템플릿 컴포넌트
 *
 * @description 보스베이비 채팅 로그 관련 모든 템플릿 컴포넌트를 export합니다.
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-29
 */
const BossBabyChatLog = {
  SessionList,
  SessionDetail,
};

export default BossBabyChatLog;









